import { render, staticRenderFns } from "./ic-calendar.vue?vue&type=template&id=082fa0e9&"
import script from "./ic-calendar.vue?vue&type=script&lang=js&"
export * from "./ic-calendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports